import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(customParseFormat);
dayjs.extend(localizedFormat);
dayjs.locale('fr');

export { dayjs };

export function formatDayjs(
  value: unknown,
  format = 'DD MMMM YYYY',
): string {
  if (value == null || value === '') return '';
  const parsed = dayjs(value as string | Date);
  return parsed.isValid() ? parsed.format(format) : '';
}

export function toDayjs(value: unknown) {
  if (value == null || value === '') return null;
  const parsed = dayjs(value as string | Date);
  return parsed.isValid() ? parsed : null;
}
